<template>
  <div class="embed-entry">
    <p v-if="loading">正在进入 BMS…</p>
    <p v-else-if="errorMsg" class="embed-entry__error">{{ errorMsg }}</p>
  </div>
</template>

<script>
import { applyEmbedLoginResult, dispatchEmbedBootstrapStore } from '@/common/embedSession.js';

/**
 * 嵌入入口：消费 URL 中的 embedCode，写入会话后跳转目标业务页。
 */
export default {
  name: 'EmbedEntry',
  data() {
    return {
      loading: true,
      errorMsg: '',
    };
  },
  created() {
    this.bootstrapEmbed();
  },
  methods: {
    /** 调用 consume 接口并跳转 embed 业务路由 */
    async bootstrapEmbed() {
      const code = this.$route.query.code;
      if (!code) {
        this.loading = false;
        this.errorMsg = '缺少嵌入凭证，请从 OMS 重新打开';
        return;
      }
      const res = await this.$api.embedConsume({ embedCode: code }).catch(() => null);
      if (!res || res.code !== 200 || !res.result) {
        this.loading = false;
        this.errorMsg = (res && res.message) || '嵌入登录失败，请从 OMS 重新打开';
        return;
      }
      const { loginUser, targetPath } = res.result;
      applyEmbedLoginResult(this, loginUser);
      await this.$api.queryPrivileges().then((privRes) => {
        if (privRes && privRes.code === 200) {
          sessionStorage.setItem('PRIVILEGES', JSON.stringify(privRes.result));
        }
      }).catch(() => {});
      dispatchEmbedBootstrapStore(this);
      const path = targetPath || '/embed/cpSettlementSalePurchaseOrder';
      this.$router.replace({ path, query: { layout: 'embed' } });
    },
  },
};
</script>

<style scoped>
.embed-entry {
  padding: 24px;
  text-align: center;
  color: #606266;
}
.embed-entry__error {
  color: #e6a23c;
}
</style>
